import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface MaximizeChangeState {
    panelName: string;
    maximized: boolean;
}

@Injectable()
export class EntityService {

    private LATEST: string = 'Latest';

    private _currentSiteId: number;

    private _parcelListDisplayStateSubject: BehaviorSubject<boolean> = new BehaviorSubject(false);
    private _parcelListTaxYearSubject: BehaviorSubject<string> = new BehaviorSubject(this.LATEST);
    private _parcelListScrollIndex: BehaviorSubject<number> = new BehaviorSubject(null);
    private _maximizeChangeSubject: BehaviorSubject<MaximizeChangeState> = new BehaviorSubject(null);

    private _parcelListDisplayState$: Observable<boolean> = this._parcelListDisplayStateSubject.asObservable();
    private _parcelListTaxYear$: Observable<string> = this._parcelListTaxYearSubject.asObservable();
    private _parcelListScrollIndex$: Observable<number> = this._parcelListScrollIndex.asObservable();
    private _maximizeChange$: Observable<MaximizeChangeState> = this._maximizeChangeSubject.asObservable();

    set currentSiteId(id: number) {
        this._currentSiteId = id;
    }

    get currentSiteId(): number {
        return this._currentSiteId;
    }

    get editGroup(): string {
        return 'site';
    }

    get parcelListDisplayState$(): Observable<boolean> {
        return this._parcelListDisplayState$;
    }

    get parcelListTaxYear$(): Observable<string> {
        return this._parcelListTaxYear$;
    }

    get parcelListScrollIndex$(): Observable<number> {
        return this._parcelListScrollIndex$;
    }

    get maximizeChange$(): Observable<MaximizeChangeState> {
        return this._maximizeChange$;
    }

    reset(): void {
        this._parcelListDisplayStateSubject.next(false);
        this._parcelListTaxYearSubject.next(this.LATEST);
        this._parcelListScrollIndex.next(null);
    }

    setMaximizeChange(changeData: MaximizeChangeState): void {
        this._maximizeChangeSubject.next(changeData);
    }

    setParcelListScrollIndex(index: number): void {
        this._parcelListScrollIndex.next(index);
    }

    changeParcelListDisplayState(toggleValue: boolean): void {
        if (this._parcelListDisplayStateSubject.getValue() !== toggleValue) {
            this._parcelListDisplayStateSubject.next(toggleValue);
        }
    }

    changeParcelListTaxYear(taxYear: string): void {
        if (this._parcelListTaxYearSubject.getValue() !== taxYear) {
            this._parcelListTaxYearSubject.next(taxYear);
        }
    }
}
